<template>
  <!-- zoom / transform 이 없는 껍데기라야 안쪽 dim 이 화면 전체를 덮는다 -->
  <div>
    <!-- 뒤 화면을 가려 클릭을 막는다 -->
    <div class="regionCheckDim"></div>

    <div
      style="
        zoom: 0.6;
        top: 48%;
        left: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
        font-family: cookiebold;
        z-index: 10000000;
      "
    >
      <div class="modaltitle">
        <div style="margin-left: 450px; margin-top: 37px">
          <p
            style="
              color: rgb(13, 13, 126);
              font-size: 45px;
              font-weight: bold;
              position: absolute;
              margin-top: 5px;
            "
          >
            Info
          </p>
          <p
            style="
              color: white;
              font-size: 45px;
              font-weight: bold;
              position: absolute;
            "
          >
            Info
          </p>
        </div>
      </div>
      <div class="modalcontent">
        <div
          style="
            font-size: 40px;
            position: absolute;
            top: 31%;
            text-align: center;
            width: 100%;
          "
        >
          <!-- 번역 문구의 \n 을 그대로 줄바꿈으로 쓴다 -->
          <p style="white-space: pre-line; line-height: 1.4"><span
              v-for="(seg, i) in segments"
              :key="i"
              :class="{ locationText: seg.highlight }"
            >{{ seg.text }}</span></p>
        </div>
        <div style="position: absolute; margin-top: 440px; width: 100%">
          <div style="margin-left: 225px">
            <div @click="cancel()" class="nobtn"></div>
            <div @click="ok()" class="yesbtn"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    // 국가 이름만 따로 색을 입히기 위해 문구를 잘라둔다
    segments() {
      const { text, location } = this.$store.state.regionCheck;

      if (!location) {
        return [{ text, highlight: false }];
      }

      return text.split(location).reduce((acc, part, i) => {
        if (i > 0) {
          acc.push({ text: location, highlight: true });
        }

        acc.push({ text: part, highlight: false });

        return acc;
      }, []);
    },
  },
  methods: {
    ok() {
      window.dispatchEvent(new CustomEvent('regionCheck'))

      this.cancel();
    },
    cancel() {
      this.$store.state.regionCheck = {
        status: false,
        type: '',
        text: '',
        location: '',
      }
    },
  },
};
</script>

<style scoped>
.regionCheckDim {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  /* 모달(10000000)보다 한 단계 아래에 깔려 뒤쪽 클릭을 모두 받아낸다 */
  z-index: 9999999;
}

.locationText {
  color: #007adc;
}

.nobtn {
  background-image: url("../assets/Btn_No.png");
  background-size: 100%;
  width: 250px;
  height: 95px;
  cursor: pointer;
  float: left;
  margin-right: 40px;
  border-radius: 40px;
}

.yesbtn {
  background-image: url("../assets/Btn_Yes.png");
  background-size: 100%;
  width: 250px;
  height: 95px;
  cursor: pointer;
  float: left;
}

.nobtn:hover,
.yesbtn:hover {
  filter: brightness(0.8);
}

.modaltitle {
  background-image: url("../assets/modaltitlepanel.png");
  background-size: 100%;
  width: 1000px;
  height: 160px;
  position: absolute;
  margin-top: -50px;
  margin-left: 0px;
}

.modalcontent {
  background-image: url("../assets/modalPopup.png");
  background-size: 100%;
  width: 900px;
  height: 570px;
  min-width: 1000px;
}
</style>